module.exports = __webpack_public_path__ + "static/village_card_img4@2x-658e8c4166c96ded81e46d99688cb1f2.png";